import { AssetClassUserEvents } from "../analytics/events/asset_classes";
import { track } from "../analytics/track";

// // // //

export function trackChangeNetFlowsTimeframe(props: {
    prevValue: string;
    nextValue: string;
}) {
    track(AssetClassUserEvents.ChangeNetFlowsTimeframe, props);
}
